import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import DeviceDropdown from "../helper_functions/DeviceDropdown.jsx";
// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"
import Card from "components/Card"
import CardBody from "components/CardBody"
import CardHeader from "components/CardHeader"

// Assets
import userProfileStyles from "./userProfileStyles.jsx"

// Services
import {primaryColor} from "../../assets/jss/material-dashboard-pro-react";
import {connect} from "react-redux";
import RobotPlatformDetail from "./RobotPlatformDetail";
import DockingImplementDetail from "./DockingImplementDetail";


class DeviceDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}

    this.timer = null
    this._is_mounted = false
  }

  componentDidMount() {
    this._is_mounted = true
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    this._is_mounted = false
  }

  render() {
    const {device_name, device_type} = this.props

    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader>
              <h4 style={{color: primaryColor}}><b>State Detail - {device_name}</b></h4>
              <DeviceDropdown allowed_device_types={["XENION_CONNECT", "XENION_A6", "LUMION_FIX", "DIV01"]}/>
            </CardHeader>
            <CardBody>
              {["LUMION_FIX", "XENION_CONNECT", "XENION_A6"].includes(device_type) &&
                <RobotPlatformDetail/>
              }
              {device_type === "DIV01" &&
                <DockingImplementDetail/>
              }
              {!["LUMION_FIX", "DIV01", "XENION_CONNECT", "XENION_A6"].includes(device_type) &&
                <div>
                  The state visualisation for this device type ({device_type}) is not yet implemented.
                  <br/>
                  Contact your Nimbus manager to implement this.
                </div>
              }
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>)
  }
}

function mapStateToProps(state) {
  const {device_serial, all_devices} = state.device_fleet

  let device_name = ""
  all_devices.forEach((device)=>{
    if (device["serial"] === device_serial){
      device_name = device["name"]
    }
  })

  let device_type = ""
  if (state.device_fleet && state.device_fleet.all_commissioned_devices) {
    state.device_fleet.all_commissioned_devices.forEach((device) => {
      if (device_serial === device["serial"]) {
        device_type = device["device_type"]
      }
    })
  }
  return {
    device_serial, device_name, device_type
  }
}


export default withStyles(userProfileStyles)(connect(mapStateToProps)(DeviceDetail))
